window.GenericConfirmModal = function (handle, callback) {
    $(handle).on('click', 'button[type=submit]', callback);
} 